module.exports = __webpack_public_path__ + "img/运动小秘详情页_06.42f6aa29.jpg";